import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX, FiScale, FiUsers, FiDollarSign } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/request-service', label: 'Get Legal Help' },
    { path: '/for-lawyers', label: 'For Lawyers' },
    { path: '/pricing', label: 'Pricing' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <SafeIcon icon={FiScale} className="w-8 h-8 text-blue-700" />
            <span className="text-xl font-bold text-gray-900">
              Legal<span className="text-green-600">Coupon</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`font-medium transition-colors ${
                  isActive(item.path)
                    ? 'text-blue-700 border-b-2 border-blue-700 pb-1'
                    : 'text-gray-700 hover:text-blue-700'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <Link
              to="/request-service"
              className="btn-primary text-white px-6 py-2 rounded-lg font-medium"
            >
              Get Legal Discount
            </Link>
            <Link
              to="/for-lawyers"
              className="btn-secondary text-blue-700 px-6 py-2 rounded-lg font-medium"
            >
              List Your Firm
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2"
          >
            <SafeIcon
              icon={isMenuOpen ? FiX : FiMenu}
              className="w-6 h-6 text-gray-700"
            />
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="md:hidden py-4 border-t border-gray-100"
          >
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`font-medium transition-colors ${
                    isActive(item.path) ? 'text-blue-700' : 'text-gray-700'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <div className="flex flex-col space-y-2 pt-4">
                <Link
                  to="/request-service"
                  onClick={() => setIsMenuOpen(false)}
                  className="btn-primary text-white px-6 py-2 rounded-lg font-medium text-center"
                >
                  Get Legal Discount
                </Link>
                <Link
                  to="/for-lawyers"
                  onClick={() => setIsMenuOpen(false)}
                  className="btn-secondary text-blue-700 px-6 py-2 rounded-lg font-medium text-center"
                >
                  List Your Firm
                </Link>
              </div>
            </nav>
          </motion.div>
        )}
      </div>
    </header>
  );
};

export default Header;